import { jsx } from "react/jsx-runtime";
import assert from "assert";
import { forwardRef, useContext } from "react";
import { Box } from "../Box/Box.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import { TableContext, TableFooterContext } from "./TableContext.mjs";
import { tableSection } from "./Table.css.mjs";
const TableFooter = forwardRef(({ children, data, ...restProps }, ref) => {
  const tableContext = useContext(TableContext);
  assert(tableContext, "TableFooter must be used within a Table component");
  return /* @__PURE__ */ jsx(TableFooterContext.Provider, { value: true, children: /* @__PURE__ */ jsx(
    Box,
    {
      component: "tfoot",
      className: tableSection,
      ref,
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children
    }
  ) });
});
export {
  TableFooter
};
